import { useEffect } from "react";
import { useLayerStructuralActions } from "../components/MainVidPlayer/useLayerStructuralActions";
import { useMst } from "../stores/main";
import { isKeyboardShortcutSuppressedTarget } from "./keyboardShortcutGuards";

function isLayerDeleteKey(e: KeyboardEvent): boolean {
  return e.key === "Delete" || e.key === "Backspace";
}

/**
 * Hook that sets up keyboard shortcut for deleting selected layers:
 * - Delete / Backspace deletes the current layer inspector selection
 */
export function useLayerDeletionShortcuts() {
  const { currentTab, playerStore } = useMst();
  const { deleteLayers } = useLayerStructuralActions();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        isKeyboardShortcutSuppressedTarget(e.target) ||
        !isLayerDeleteKey(e)
      ) {
        return;
      }

      if (
        currentTab !== "layers" ||
        !playerStore.layerInspectorEnabled ||
        playerStore.layerInspectorMode !== "design" ||
        !playerStore.layerInspectorSelections.length
      ) {
        return;
      }

      e.preventDefault();
      if (e.repeat) {
        return;
      }

      deleteLayers();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [currentTab, deleteLayers, playerStore]);
}
